import celine from './compressed/Celine.webp';
import eloi from './compressed/Eloi.webp';
import laura from './compressed/Laura.webp';
import mustapha from './compressed/Mustapha.webp';
import pierre from './compressed/Pierre.webp';
import yosri from './compressed/Yosri.webp';
import zoe from './compressed/Zoe.webp';

export const PEOPLE_IMAGES = [pierre, eloi, laura, zoe, celine, yosri, mustapha];
